<div class="container">

  <header class="page-heading">
    <h1>SWP Calculator</h1>
    <p>Plan your Systematic Withdrawal Plan (SWP) — see how long your corpus lasts and your total withdrawals over time.</p>
  </header>

  <div class="card mb-lg">
    <div class="section-title">SWP Details</div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('initialInvestment')">
        <label class="field-label" for="initialInvestment">Initial Investment</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="initialInvestment" type="number"
            [(ngModel)]="initialInvestment"
            [min]="C.initialInvestment.min" [max]="C.initialInvestment.max" [step]="C.initialInvestment.step"
            (ngModelChange)="onFieldChange('initialInvestment')"
            (blur)="onFieldBlur('initialInvestment')"
            placeholder="e.g. 20,00,000"
            autocomplete="off"/>
        </div>
        @if (hasError('initialInvestment')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('initialInvestment') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('monthlyWithdrawal')">
        <label class="field-label" for="monthlyWithdrawal">Monthly Withdrawal</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="monthlyWithdrawal" type="number"
            [(ngModel)]="monthlyWithdrawal"
            [min]="C.monthlyWithdrawal.min" [max]="C.monthlyWithdrawal.max" [step]="C.monthlyWithdrawal.step"
            (ngModelChange)="onFieldChange('monthlyWithdrawal')"
            (blur)="onFieldBlur('monthlyWithdrawal')"
            placeholder="e.g. 15,000"
            autocomplete="off"/>
        </div>
        @if (hasError('monthlyWithdrawal')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('monthlyWithdrawal') }}
          </div>
        }
      </div>
    </div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('annualRate')">
        <label class="field-label" for="annualRate">Expected Annual Return</label>
        <div class="input-shell suffix">
          <input id="annualRate" type="number"
            [(ngModel)]="annualRate"
            [min]="C.rate.min" [max]="C.rate.max" [step]="C.rate.step"
            (ngModelChange)="onFieldChange('annualRate')"
            (blur)="onFieldBlur('annualRate')"
            placeholder="e.g. 8"
            autocomplete="off"/>
          <span class="affix right">%</span>
        </div>
        @if (hasError('annualRate')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('annualRate') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('tenureYears')">
        <label class="field-label" for="tenureYears">Withdrawal Duration (max)</label>
        <div class="input-shell suffix">
          <input id="tenureYears" type="number"
            [(ngModel)]="tenureYears"
            [min]="C.tenureYears.min" [max]="C.tenureYears.max" [step]="C.tenureYears.step"
            (ngModelChange)="onFieldChange('tenureYears')"
            (blur)="onFieldBlur('tenureYears')"
            placeholder="e.g. 20"
            autocomplete="off"/>
          <span class="affix right">Yr</span>
        </div>
        <div class="field-hint">Simulation stops earlier if your corpus depletes first</div>
        @if (hasError('tenureYears')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('tenureYears') }}
          </div>
        }
      </div>
    </div>

    <div class="action-row">
      <button type="button" class="btn btn-primary" (click)="calculate()" [class.btn-disabled]="showFormErrors && !isFormValid">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        Calculate
      </button>
      @if (calculated) {
        <button type="button" class="btn btn-secondary" (click)="reset()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
          Reset
        </button>
      }
      @if (showFormErrors && !isFormValid) {
        <span class="form-error-hint">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Fix the errors above to calculate
        </span>
      }
    </div>
  </div>

  @if (calculated && result) {
    @if (result.depletedAtMonth) {
      <div class="savings-banner mb-md" style="background: linear-gradient(90deg, #dc2626 0%, #ef4444 100%);">
        <div class="sb-item">
          <div class="sb-val">Corpus depleted in month {{ result.depletedAtMonth }}</div>
          <div class="sb-lbl">({{ Math.floor(result.depletedAtMonth/12) }}y {{ result.depletedAtMonth%12 }}m of withdrawals)</div>
        </div>
      </div>
    }

    <div class="summary-grid mb-md">
      <div class="summary-card c-green">
        <div class="sc-icon"></div>
        <div class="sc-label">Total Withdrawn</div>
        <div class="sc-value">{{ fmt.currency(result.totalWithdrawn) }}</div>
      </div>
      <div class="summary-card c-blue">
        <div class="sc-icon"></div>
        <div class="sc-label">Remaining Balance</div>
        <div class="sc-value">{{ fmt.currency(result.finalBalance) }}</div>
      </div>
      <div class="summary-card c-red">
        <div class="sc-icon"></div>
        <div class="sc-label">Corpus Lasted</div>
        <div class="sc-value">
          @if (result.depletedAtMonth) {
            {{ Math.floor(result.depletedAtMonth/12) }}y {{ result.depletedAtMonth%12 }}m
          } @else {
            {{ tenureYears }}y (full duration)
          }
        </div>
      </div>
    </div>

    <div class="card charts-card mb-md">
      <div class="section-title">Visual Breakdown</div>
      <div class="charts-top-row">
        <div class="chart-panel">
          <div class="chart-panel-label">Withdrawn vs Remaining</div>
          <div class="chart-canvas-wrap chart-canvas-pie">
            <canvas #breakdownRef></canvas>
          </div>
        </div>
        <div class="chart-panel chart-panel-bar">
          <div class="chart-panel-label">Balance Over Time</div>
          <div class="chart-canvas-wrap">
            <canvas #growthRef></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-md">
      <div class="section-title">Withdrawal Schedule</div>

      <div class="tab-bar">
        <button type="button" class="tab-btn" [class.active]="activeTab==='yearly'" (click)="activeTab='yearly'">
          Yearly Summary
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab==='monthly'" (click)="activeTab='monthly'">
          Full Monthly Schedule
        </button>
        <div class="tab-count">
          @if (activeTab === 'yearly') { {{ result.years.length }} years }
          @else { {{ result.months.length }} months }
        </div>
      </div>

      @if (activeTab === 'yearly') {
        <div class="tbl-wrap">
          <table>
            <thead>
              <tr>
                <th class="t-left">Year</th>
                <th class="t-prepay">Withdrawn</th>
                <th class="t-balance">Balance</th>
              </tr>
            </thead>
            <tbody>
              @for (row of result.years; track row.year) {
                <tr>
                  <td class="t-left t-year">Year {{ row.year }}</td>
                  <td class="t-prepay">{{ fmt.currency(row.withdrawnThisYear) }}</td>
                  <td class="t-balance">{{ fmt.currency(row.balance) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (activeTab === 'monthly') {
        <div class="tbl-wrap">
          <table>
            <thead>
              <tr>
                <th class="t-left">#</th>
                <th class="t-interest">Interest Earned</th>
                <th class="t-prepay">Withdrawn</th>
                <th class="t-balance">Balance</th>
              </tr>
            </thead>
            <tbody>
              @for (row of result.months; track row.month) {
                <tr>
                  <td class="t-left t-num">Month {{ row.month }}</td>
                  <td class="t-interest">{{ fmt.currency(row.interest) }}</td>
                  <td class="t-prepay">{{ fmt.currency(row.withdrawal) }}</td>
                  <td class="t-balance">{{ fmt.currency(row.balance) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
</div>

<!-- ══ SEO CONTENT ══════════════════════════════════════════════════════ -->
<section class="container seo-content">
  <div class="card">
    <h2 class="section-title">How is SWP Calculated?</h2>
    <p>
      A Systematic Withdrawal Plan (SWP) lets you withdraw a fixed amount every month from an
      existing lumpsum investment while the remaining balance continues to earn returns. Each
      month, the balance grows by the expected monthly return and then the withdrawal is deducted.
    </p>
    <p>
      If withdrawals exceed what the corpus can sustain, the balance eventually depletes to zero —
      this calculator simulates month by month and flags the exact month your corpus would run out,
      if it happens before your chosen duration ends.
    </p>

    <h2 class="section-title mt-sm">Frequently Asked Questions</h2>
    <div class="faq-item">
      <h3>How long will my corpus last with an SWP?</h3>
      <p>
        It depends on your withdrawal rate relative to your expected return. If your monthly
        withdrawal is smaller than the return the corpus generates, the balance can theoretically
        last indefinitely; otherwise it gradually depletes.
      </p>
    </div>
    <div class="faq-item">
      <h3>Is SWP better than withdrawing a lumpsum?</h3>
      <p>
        SWP lets the uninvested portion keep earning returns while you draw a regular income, and
        can also be more tax-efficient than a one-time withdrawal, depending on applicable capital
        gains rules.
      </p>
    </div>
  </div>
</section>
